/**
 * pdp-perf.js  (Avinos, V145 - 26 okt 2026)
 * Alleen op productpagina's, geladen met defer NA theme.js (layout/theme.liquid).
 *
 * 1. PHOTOSWIPE LAZY
 *    De zoom-lightbox (PhotoSwipe, 39 KB) zit op productpagina's niet meer in
 *    de vendor-bundel (assets/vendor-pdp-v2.js) maar in assets/photoswipe-v1.js.
 *    Dit script:
 *      - haalt dat bestand op zodra de pagina geladen is en de browser even
 *        niets te doen heeft (requestIdleCallback), of eerder zodra iemand de
 *        galerij aanraakt;
 *      - zet een wachter om theme.Photoswipe.prototype.initGallery: wordt de
 *        zoom aangetikt voordat het bestand binnen is, dan wordt het eerst
 *        geladen en opent de lightbox direct daarna. De bezoeker merkt hooguit
 *        een fractie van een seconde vertraging bij een extreem snelle tik.
 *    De URL van photoswipe-v1.js komt uit data-photoswipe-src op dit script-
 *    element (gezet in layout/theme.liquid met asset_url, dus met cache-buster).
 */
(function () {
  'use strict';

  var me = document.currentScript;
  var PS_SRC = me && me.getAttribute('data-photoswipe-src');
  var loading = null;

  function has() {
    return !!(window.PhotoSwipe && window.PhotoSwipeUI_Default);
  }

  function loadPhotoswipe() {
    if (has()) return Promise.resolve();
    if (loading) return loading;
    if (!PS_SRC) return Promise.reject(new Error('pdp-perf: photoswipe src ontbreekt'));
    loading = new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = PS_SRC;
      s.async = true;
      s.onload = function () { resolve(); };
      s.onerror = function () { reject(new Error('pdp-perf: photoswipe laden mislukt')); };
      document.head.appendChild(s);
    }).then(function () {
      loading = null;
      if (!has()) throw new Error('pdp-perf: photoswipe geladen maar niet gedefinieerd');
    }, function (err) {
      loading = null;
      throw err;
    });
    return loading;
  }
  window.__avinosLoadPhotoswipe = loadPhotoswipe;

  /* Wachter om theme.Photoswipe: pas zetten als theme.js er is. theme.js laadt
     met defer VOOR dit bestand, dus theme.Photoswipe bestaat hier al; het
     load-event is een vangnet voor als de volgorde ooit wisselt. */
  function guardGallery() {
    var P = window.theme && window.theme.Photoswipe;
    if (!P || !P.prototype || typeof P.prototype.initGallery !== 'function' || P.prototype.__avinosLazy) return;
    var orig = P.prototype.initGallery;
    P.prototype.initGallery = function () {
      var self = this, args = arguments;
      if (has()) return orig.apply(self, args);
      loadPhotoswipe().then(function () { orig.apply(self, args); }, function (err) {
        if (window.console && console.warn) console.warn(err && err.message);
      });
    };
    P.prototype.__avinosLazy = true;
  }
  guardGallery();
  window.addEventListener('load', guardGallery, { once: true });

  /* Alvast ophalen: bij de eerste aanraking van de galerij, of anders zodra
     de pagina klaar is en de browser idle is. */
  function warm() {
    window.removeEventListener('pointerdown', warmOnGallery, true);
    window.removeEventListener('touchstart', warmOnGallery, true);
    loadPhotoswipe().catch(function () {});
  }
  function warmOnGallery(e) {
    var t = e.target;
    if (t && t.closest && t.closest('[data-product-images], .product__photos, .js-photoswipe__zoom')) warm();
  }
  window.addEventListener('pointerdown', warmOnGallery, { capture: true, passive: true });
  window.addEventListener('touchstart', warmOnGallery, { capture: true, passive: true });

  function idleWarm() {
    if (window.requestIdleCallback) {
      requestIdleCallback(warm, { timeout: 4000 });
    } else {
      setTimeout(warm, 2500);
    }
  }
  if (document.readyState === 'complete') {
    idleWarm();
  } else {
    window.addEventListener('load', idleWarm, { once: true });
  }
})();
